const initializeMessageReplies = () => {
    const composer =
    document.querySelector(
        '[data-message-composer]'
    );

    if (!composer) {
        return;
    }

    const parentInput =
        composer.querySelector(
            '[data-reply-parent-id]'
        );

    const preview =
        composer.querySelector(
            '[data-reply-preview]'
        );

    const sender =
        composer.querySelector(
            '[data-reply-sender]'
        );

    const body =
        composer.querySelector(
            '[data-reply-body]'
        );

    const cancelButton =
        composer.querySelector(
            '[data-reply-cancel]'
        );

    const textarea =
        composer.querySelector(
            'textarea[name="body"]'
        );

    if (
        !parentInput
        || !preview
        || !sender
        || !body
        || !cancelButton
        || !textarea
    ) {
        return;
    }

    const clearReply = () => {
        parentInput.value = '';

        sender.textContent = '';

        body.textContent = '';

        preview.classList.add(
            'hidden'
        );
    };
	
	composer.clearReplyPreview =
    clearReply;

    document.addEventListener(
        'click',
        (event) => {
            const target =
                event.target;

            if (
                !(target instanceof Element)
            ) {
                return;
            }

            const replyButton =
                target.closest(
                    '[data-message-reply]'
                );

            if (replyButton) {
                parentInput.value =
                    replyButton.dataset
                        .messageId
                    || '';

                sender.textContent =
                    replyButton.dataset
                        .messageSender
                    || 'Member';

                body.textContent =
                    replyButton.dataset
                        .messageBody
                    || '';

                preview.classList.remove(
                    'hidden'
                );

                textarea.focus();

                composer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                });

                return;
            }

            if (
                target.closest(
                    '[data-reply-cancel]'
                )
            ) {
                clearReply();

                textarea.focus();
            }
        }
    );

    composer.addEventListener(
        'reset',
        () => {
            window.setTimeout(
                clearReply,
                0
            );
        }
    );
};

const highlightLinkedMessage = () => {
    if (!window.location.hash) {
        return;
    }

    const message =
        document.querySelector(
            window.location.hash
        );

    if (!message) {
        return;
    }

    message.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
    });

    message.classList.add(
        'ring-2',
        'ring-cyan-300',
        'ring-offset-4',
        'ring-offset-slate-950'
    );

    window.setTimeout(
        () => {
            message.classList.remove(
                'ring-2',
                'ring-cyan-300',
                'ring-offset-4',
                'ring-offset-slate-950'
            );
        },
        1800
    );
};

window.addEventListener(
    'hashchange',
    highlightLinkedMessage
);

const initializeMessageReplyFeatures = () => {
    initializeMessageReplies();
    highlightLinkedMessage();
};

if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeMessageReplyFeatures
    );
} else {
    initializeMessageReplyFeatures();
}